import LockoutModalContent from '../LockoutModalContent';
import Modal, { ModalProps } from '../Modal';
import React from 'react';
import { LockoutModalVariant } from '../../constants/lockout';
import { useUserContext } from '@osmosis/nextjs-components/context/UserContext';
import TrialAbuseRestrictionModal from './TrialAbuseRestrictionModal';

type LockoutModalProps = {
  modalProps: ModalProps;
  headerMessage?: React.ReactNode;
  bodyMessage?: React.ReactNode;
  variant?: LockoutModalVariant;
  identifier?: string;
};

/**
 * LockoutModal component.
 */
const LearnLockoutModal = (props: LockoutModalProps) => {
  const { identifier, headerMessage, bodyMessage, variant } = props;
  const { trialAbuseRestricted } = useUserContext();

  const handleClose = () => {
    const modalData = props.modalProps.data as
      | { onClose?: () => void }
      | undefined;
    modalData?.onClose?.();
    props.modalProps.hide();
  };

  if (trialAbuseRestricted) {
    return (
      <TrialAbuseRestrictionModal {...props.modalProps} hide={handleClose} />
    );
  }

  return (
    <div data-testid="video-lockout-modal">
      <Modal
        role="dialog"
        isVisible={props.modalProps.isVisible}
        hide={handleClose}
        _className={props.modalProps._className}
      >
        <LockoutModalContent
          dataTestId={`${identifier}`}
          onClose={handleClose}
          closeButton={true}
          headerMessage={headerMessage}
          bodyMessage={bodyMessage}
          variant={variant}
        />
      </Modal>
    </div>
  );
};

export default LearnLockoutModal;
